'use strict';

(function ($) {

	/**
  * Copytext
  *
  * @author Mathias Hayoz <mathias.hayoz@namics.com>
  */
	T.Module.Copytext = T.createModule({
		_selectors: {
			text: '[data-js-m-copytext__text]',
			icon: 'a[data-icon]',
			links: 'a',
			linklist: 'ul > li > a'
		},

		_downloads: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.zip', '.jpg', '.jpeg', '.png', '.gif', '.tif'],

		_externalLinks: ['www', 'http'],

		start: function start(resolve) {
			var _this = this;

			this.$ctx = $(this._ctx);

			this.$text = this.$ctx.find(this._selectors.text);
			this.$linksWithIcons = this.$text.find(this._selectors.icon);
			this.$linklist = this.$text.find(this._selectors.linklist);
			this.$links = this.$text.find(this._selectors.links);

			this.$links.each(function (index, element) {
				var $link = $(element);
				var href = $link.attr('href');
				var currentHostname = window.location.hostname;
				var hrefHostname = _this.getHostnameFromString(href);

				if (_this.stringEndsWithArray(href, _this._downloads)) {
					$link.append('<svg class="a-icon a-icon--small i i-download"><use xlink:href="#download"></use></svg>');
				}

				if (_this.stringStartsWithArray(href, _this._externalLinks) && currentHostname !== hrefHostname) {
					$link.append('<svg class="a-icon a-icon--small i i-external"><use xlink:href="#external"></use></svg>');
				}
			});

			this.$linksWithIcons.each(function (index, element) {
				var $element = $(element);
				var icon = $element.data('icon');

				$element.append('<svg class="a-icon a-icon--small i i-' + icon + '"><use xlink:href="#' + icon + '"></use></svg>');
			});

			this.$linklist.each(function (index, element) {
				var $element = $(element);
				var icon = 'link-small';

				$element.append('<svg class="a-icon a-icon--small i i-' + icon + '"><use xlink:href="#' + icon + '"></use></svg>');
			});

			resolve();
		},


		/**
   * Checks if value ends with one of the strings in array.
   *
   * @param {string} value The href value.
   * @param {Array} array An array of string endings.
   * @returns {boolean} Is it a match?
         */
		stringEndsWithArray: function stringEndsWithArray(value, array) {
			var match = false;

			array.forEach(function (ending) {
				if (value.endsWith(ending)) {
					match = true;
				}
			});

			return match;
		},


		/**
   * Checks if value starts with one of the strings in array.
   *
   * @param {string} value The href value.
   * @param {Array} array An array of string starts.
   * @returns {boolean} Is it a match?
   */
		stringStartsWithArray: function stringStartsWithArray(value, array) {
			var match = false;

			array.forEach(function (start) {
				if (value.startsWith(start)) {
					match = true;
				}
			});

			return match;
		},


		/**
   * Returns the hostname of a string by creating a link element.
   *
   * @param {string} href The url string.
   * @returns {string} The hostname.
         */
		getHostnameFromString: function getHostnameFromString(href) {
			var link = document.createElement('a');
			link.href = href;
			return link.hostname;
		}
	});
})(jQuery);